import { TApiError } from "../common/message";
import http from "../services/http.service";
import { ConfirmCodeApiResponse } from "./apiTypes";
import { AxiosError } from "axios";
import {queries} from "./queries";

export const signin = (
  username: string,
  password: string,
  onSuccess: (data: ConfirmCodeApiResponse) => void,
  onError: (err: AxiosError<TApiError>) => void
) => {
  http
    .post(queries.auth.signin, {
      username,
      password,
    })
    .then((res) => {
      console.log("signin", res);
      onSuccess(res.data);
    })
    .catch(onError);
};

export const signout = (
  refresh: string,
  onSuccess: () => void,
  onError: (e: AxiosError<TApiError>) => void
) => {
  http
    .post(queries.auth.signout, { refresh })
    .then(() => {
      console.log("signout");
      onSuccess();
    })
    .catch(onError);
};
export const verifyToken = (token: string | null) => {
  return http.post(queries.auth.token.verify, { token });
};

export const refreshToken = (refresh: string | null) => {
  return http.post(queries.auth.token.refresh, { refresh });
};
